module.exports = __webpack_public_path__ + "static/img/p1.5ac3ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/p1.png
// module id = RtRT
// module chunks = 0